<template>
  <div class="col-lg-12">
    <div class="row d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <span class="ml-2 label-bold color-dark-purple">HISTÓRICO PROFISSIONAL
        </span>
      </div>
      <div>
        <button
          type="button"
          class="f14 btn-add-items-tb bg-light-purple color-white"
          @click="openForm()"
        >
          ADICIONAR
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div
        class="d-flex justify-content-center align-item-center row mb-1 border-dark-purple pt-3 pb-4"
        v-if="experiences.length === 0"
      >
        <h4 class="center f15 color-dark-purple">
          NENHUMA EXPERIÊNCIA PROFISSIOINAL FOI INFORMADA AINDA.
        </h4>
      </div>
    </div>

    <div
      v-for="(experience, index) in experiences"
      :key="experience.id"
    >
      <div class="mt-3">
        <div class="row mb-1 border-dark-purple pt-3 pb-4">
          <div class="col-lg-12">
            <div>
              <div class="d-flex justify-content-between">
                <div>
                  <span
                    class="label-bold color-dark-purple"
                  >{{ experience.occupation }}</span>
                </div>
                <div
                  style="margin-right: 10px !important"
                  class="menu_column nav nav-tabs"
                >
                  <li
                    style="background-color: #f4f4f4 !important"
                    class="nav-item dropdown"
                  >
                    <div
                      class="nav-link"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="background-color: #fcfcfc"
                    >
                      <font-awesome-icon icon="ellipsis-h" />
                    </div>
                    <div class="dropdown-menu drop-down-tb">
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="openForm(experience.id)"
                        >
                          EDITAR
                        </span>
                        <i class="ml-4 fa fa-pencil-alt scale_1" />
                      </div>
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="deleteExperience(experience.id, index)"
                        >
                          DELETAR
                        </span>
                        <i class="ml-3 fas fa-trash-alt scale_1" />
                      </div>
                    </div>
                  </li>
                </div>
              </div>
              <div>
                <span style="text-transform: capitalize">{{ experience.company }}
                  |
                  {{ experience.city }}</span>
              </div>
              <div>
                <div>
                  <span style="text-transform: capitalize">
                    {{ experience.start_date }} - {{ experience.end_date }}
                  </span>
                </div>
              </div>
              <div class="mt-3">
                <div>
                  <span style="text-transform: capitalize">Descrição:</span>
                </div>
                <div>
                  <span style="text-transform: capitalize">{{
                    experience.description
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceForm from "@/Recruiters/TalentBank/Experiences/Form.vue";
// import { format } from "date-fns";
import axios from "axios";

export default {
  props: ["candidate_id", "recruiter_id", "account_uid"],
  mounted() {
    eventBus.$on("getExperiences", () => {
      this.getExperiences();
    });
    if (this.candidate_id) {
      this.getExperiences();
    } else {
      setTimeout(() => {
        this.getExperiences();
      }, 1500);
    }
  },
  data: () => ({
    experiences: [],
    subMenu: false,
  }),
  methods: {
    getExperiences() {
      this.experiences = [];
      let url = "/candidates/experiences";
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/experiences`;
      }
      axios.get(url).then((response) => {
        for (let experience of response.data.experiences) {
          this.experiences.push({
            id: experience.id,
            description: experience.description,
            start_date: this.formatHard(experience.start_work),
            end_date: experience.end_work
              ?  this.formatHard(experience.end_work)
              : "Até o momento",
            company: experience.company_name,
            occupation: experience.occupation_name,
            current_job: experience.current_job,
            city: experience.city_name + " / " + experience.state_uf,
          });
        }
      });
    },
    formatHard(date){
      if(!date){
        return date;
      }

      let new_date = date.split(' ');
      new_date = new_date[0].split('-');
      return  new_date[1] + '/' + new_date[0]
    },
    openForm(id) {
      this.$modal.show(
        ExperienceForm,
        {
          experience_id: id,
          candidate_id: this.candidate_id,
          account_uid: this.account_uid,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    deleteExperience(id, index) {
      let conf = confirm("Tem certeza que deseja excluir este histórico?");
      if (!conf) return;
      if (this.recruiter_id != null) {
        axios
          .delete(`/recruiters/talent_banks/experiences/${id}`)
          .then((response) => {
            if (response.data.status) {
              this.$toast.success("Historico excluido com sucesso!");
              if (this.experiences[index].current_job)
                eventBus.$emit("updateInfo");
              this.experiences.splice(index, 1);
              return;
            }

            this.$toast.error("Não foi possivel excluir o histórico.");
          });
      } else {
        axios.delete(`/candidates/experiences/${id}`).then((response) => {
          if (response.data.status) {
            this.$toast.success("Historico excluido com sucesso!");
            if (this.experiences[index].current_job)
              eventBus.$emit("updateInfo");
            this.experiences.splice(index, 1);
            return;
          }

          this.$toast.error("Não foi possivel excluir o histórico.");
        });
      }
    },
  },
};
</script>
